export const PREVIEW_LIST_ITEM_HEIGHT = 58;
export const PREVIEW_LIST_VISIBLE_ITEM_COUNT = 9.5;
export const PREVIEW_LIST_MODAL_HEIGHT = PREVIEW_LIST_ITEM_HEIGHT * PREVIEW_LIST_VISIBLE_ITEM_COUNT;
